import React, {FC} from 'react';
import {useDispatch} from 'react-redux';

import {
    resetData,
} from 'modules/data/data-actions';
import {MONITOR_SERVICE_FILTER_QUERY_PARAM} from 'pages/ais/monitor-services-page/monitor-service-page.constants';
import {EEntityType} from 'shared/constants/entities';
import {useQueryParams} from 'shared/utils/query-params';
import {normalizeEntityName} from 'utils/common';

import {ActionButton} from '../action-button';
import {ITableActionProps} from '../table-action-types';

import './button-action-update-table.less';

const ButtonsActionUpdateComponent: FC<ITableActionProps> = ({
    wrapper,
    meta,
    entityName,
    ...props
}: ITableActionProps) => {
    const dispatch = useDispatch();
    const {removeQueryParam} = useQueryParams();

    const handleClick = () => {
        removeQueryParam(MONITOR_SERVICE_FILTER_QUERY_PARAM);

        dispatch(resetData({
            entityType: meta?.parentEntityType || EEntityType.TABLE,
            entityName: normalizeEntityName(entityName),
            loading: false,
        }));
    };

    const Component = wrapper || ActionButton;

    return (
        <Component
            {...props}
            onClick={handleClick}
            actionIcon={meta.actionIcon}
            className="update-button"
        >
            {meta.actionTitle}
        </Component>
    );
};

export const ButtonsActionUpdate = ButtonsActionUpdateComponent;
